import React, { FunctionComponent } from "react";
import { isValueValid } from "../lib/internal-columns";
import { TimeCellComponentProps } from "../types/data-table.types";
import { TextCellContents } from "./text-cell-renderer";

/**
 * Used as cellRenderer for data table column of type "text"
 */
export const TimeCellComponent: FunctionComponent<TimeCellComponentProps> = ({ node, required, value }) => (
    <TextCellContents valid={isValueValid(node, value, required)}>{value?.displayText}</TextCellContents>
);
